import { DisplayContainer } from '../../../../components/Support/DisplayContainer/DisplayContainer';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { donedealBreakpoints } from 'styled-system';
import { VERTICAL } from '../../../../helpers/verticals';

interface BaseHeaderProps {
  readonly vertical: VERTICAL;
  readonly children: ReactNode;
  readonly cdnUrl: string;
  readonly variant: string;
  readonly useGenericLogo: boolean;
}

const Wrapper = styled.header`
  padding: ${({ theme }) => `${theme.spacing.S8} 0`};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${donedealBreakpoints.media.large} {
    padding: ${({ theme }) => `${theme.spacing.M16} 0`};
  }
`;

export const Right = styled.div`
  display: flex;
  align-content: end;
  margin-left: auto;

  > * {
    margin-left: ${({ theme }) => `${theme.spacing.S12}`};

    @media (min-width: 840px) {
      margin-left: ${({ theme }) => `${theme.spacing.M24}`};
    }
  }
`;

const LogoWrapper = styled.a`
  display: block;
  position: relative;
`;

const Logo = styled.img`
  height: 100%;
  width: 100%;
`;

function BaseHeader({
  children,
  vertical,
  cdnUrl,
  variant,
  useGenericLogo,
}: BaseHeaderProps) {
  const renderLogo = () => {
    if (useGenericLogo) {
      return (
        <Logo
          src={`${cdnUrl}/images/logos/donedeal-logo${
            variant === 'TRANSPARENT' ? '-white' : ''
          }.svg`}
          alt="DoneDeal"
        />
      );
    }

    switch (vertical) {
      case VERTICAL.FARMING:
        return (
          <Logo
            src={`${cdnUrl}/images/logos/donedeal-logo-${
              variant === 'TRANSPARENT' ? 'white-' : ''
            }agri.svg`}
            alt="DoneDeal Farming"
          />
        );
      case VERTICAL.MOTOR:
        return (
          <Logo
            src={`${cdnUrl}/images/logos/donedeal-logo-${
              variant === 'TRANSPARENT' ? 'white-' : ''
            }cars.svg`}
            alt="DoneDeal Motor"
          />
        );
      case VERTICAL.MARKETPLACE:
        return (
          <>
            <DisplayContainer
              config={{ small: 'block', medium: 'none', large: 'none' }}
            >
              <Logo
                src={`${cdnUrl}/images/logos/donedeal-logo-${
                  variant === 'TRANSPARENT' ? 'white-' : ''
                }market.svg`}
                alt="DoneDeal Market"
              />
            </DisplayContainer>
            <DisplayContainer
              config={{ small: 'none', medium: 'block', large: 'block' }}
            >
              <Logo
                src={`${cdnUrl}/images/logos/donedeal-logo-${
                  variant === 'TRANSPARENT' ? 'white-' : ''
                }marketplace.svg`}
                alt="DoneDeal Marketplace"
              />
            </DisplayContainer>
          </>
        );
    }
  };

  return (
    <Wrapper>
      <div>
        <LogoWrapper href={'/'} data-testid="header-logo">
          {renderLogo()}
        </LogoWrapper>
      </div>

      <Right id="base-header-wrapper">{children}</Right>
    </Wrapper>
  );
}

export { BaseHeader };
